import { z } from "zod/v4";
import { cashBookEntrySchema, euerReportSchema, sphereSummarySchema } from "../../schemas/finance";
import { fetchApi } from "../client/internal";

export const reports = {
	euer: (clubId: string, year?: number) => {
		const qs = year ? `?year=${year}` : "";
		return fetchApi(`/${clubId}/reports/euer${qs}`, euerReportSchema);
	},
	cashBook: (clubId: string, from: string, to: string) =>
		fetchApi(`/${clubId}/reports/kassenbuch?from=${from}&to=${to}`, z.array(cashBookEntrySchema)),
	spheres: (clubId: string, year?: number) => {
		const qs = year ? `?year=${year}` : "";
		return fetchApi(`/${clubId}/reports/spheres${qs}`, z.array(sphereSummarySchema));
	},
};
